import React, {useEffect, useRef} from "react";

import {EmailContact, SubjectFields} from "./EmailComponents.ts";
import {UseFormRegisterReturn} from "react-hook-form";

export const Subject = ({subjectFields, register, name}: {
    subjectFields: SubjectFields,
    register: (fieldName) => object,
    name: string
}) => {
    return <div className='d-flex align-items-center mb-1'>
        <label htmlFor='subject' className='pe-2'
               style={{width: '5em', minWidth: '5em', maxWidth: '5em'}}>Subject:</label>
        <div className="d-flex flex-wrap w-100">
            <span className='form-control' style={{
                backgroundColor: '#f4f4f4',
                cursor: 'default',
                borderRight: 'none',
                width: 'auto',
                display: 'inline-block'
            }}>{subjectFields.prefix}</span>
            <input {...register(name)} type="text" autoComplete='off' id='subject'
                   maxLength={43}
                   required={true}
                   className="form-control flex-fill"
                   style={{
                       borderLeft: 'none',
                       borderRight: 'none',
                       maxWidth: '28em',
                       width: 'auto',
                       zIndex: '5',
                       minWidth: '10em'
                   }}
                   placeholder="Subject"/>
            <span className='form-control flex-fill' style={{
                backgroundColor: '#f4f4f4',
                borderLeft: 'none',
                cursor: 'default',
                width: 'auto',
                display: 'inline-block',
                whiteSpace: 'nowrap'
            }}>{subjectFields.suffix == ' - ' ? 'Doc No. will be added before sending' : subjectFields.suffix}</span>
        </div>
        {/*<input readOnly={true} value={subjectFields.suffix} className='form-control'/>*/}
    </div>

}

export type FileInputProps = {
    fileList: File[];
    setFileList: (fileList) => void;
};
export const FileInput = ({fileList, setFileList}: FileInputProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        // if (fileList.length) {
        const dataTransfer = new DataTransfer();
        fileList.forEach((file) => dataTransfer.items.add(file));
        inputRef.current.files = dataTransfer.files;
        // }
    }, [fileList])

    return (
        <div
            className='position-relative flex-fill border-dark-subtle ps-2'>
            <label className='mb-1'>
                <span className='button d-inline-block'>Add Additional Attachments</span>
                <input
                    ref={inputRef}
                    onChange={(e) => setFileList([...fileList, ...Array.from(e.target.files)])}
                    type="file" name='attachments[]'
                    multiple={true}
                    className='opacity-0 '
                    style={{height: '1px'}}
                />
            </label>
            {!!fileList.length ? (
                <div style={{
                    position: 'relative',
                    // marginTop: '1.5rem',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1
                }}>
                    {fileList.map((v, i) => (
                        <span className={'p-1 border'}>{v.name}
                            <span onClick={() => setFileList(fileList.filter((f, _i) => _i != i))}
                                  style={{backgroundSize: '0.7rem', cursor: 'pointer'}}
                                  className='btn btn-close small'></span>
                    </span>))}
                </div>) : <div className='text-body-secondary'>Drag attachments here or click the button above</div>}
        </div>
    )
        ;
};

interface ClientEmailInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    register: (fieldName) => UseFormRegisterReturn;
    setValue: (fieldName, value) => void;
    getValues: (fieldName) => string;
    fieldName: string;
    emailContactList: EmailContact[]
}

export const ClientEmailInput = ({
                                     setValue, getValues,
                                     register,
                                     fieldName,
                                     emailContactList,
                                     ...rest
                                 }: ClientEmailInputProps) => {

    const {onChange, ...registerReturn} = register(fieldName);

    return (
        <>
            <input {...register(fieldName)} type="email" required={true} autoComplete='off' list='emails'
                   role='presentation'
                   multiple={true}
                   title='Multiple email addresses can be separated with a comma (, )'
                   style={{width: 'auto'}}
                   className="form-control mb-sm-1 flex-fill"
                   onBlur={(e) => {
                       setValue(fieldName, e.target.value?.split(',').filter(s => s).join(','))
                   }}
                   onFocus={(e) => {
                       e.target.value && setValue(fieldName, [...e.target.value.split(','), ''].join(','))
                   }}
                   onChange={e => {
                       if (e?.nativeEvent?.inputType) {
                           setValue(fieldName, e.target.value)
                       } else {
                           setValue(fieldName, e.target.value + ',')
                       }
                   }}
                   onKeyDown={(e) => {
                       if (e.key === 'Enter') {
                           e.preventDefault();
                           const currentValue = getValues(fieldName).split(',').pop();
                           const search = new RegExp(currentValue.toLowerCase().replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&').replace(' ', '.*'), 'gm');
                           const foundEmail = emailContactList.find(v => search.test(`${v.email} ${v.name}`.toLowerCase()))?.email;

                           if (foundEmail) {
                               setValue(fieldName, getValues(fieldName).replace(/[^,]+$/, foundEmail) + ',');
                           }
                       }

                   }}
                // defaultValue={clientContact?.conEmail}
                   spellCheck={false}
                   {...rest} />
        </>
    )
}
